<template>
  <v-sheet v-if="registration.id" class="pa-2 my-2">
    <h3>Payment Form</h3>
    <v-divider />
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ getEventName() }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ registration.status ? registration.status.toUpperCase() : '' }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-content style="-webkit-box-align: end;-ms-flex-align: end;align-items: flex-end;">
          <v-list-tile-title style="text-align:right;">${{ registration.status == 'pending' ? getEventCost() : '--' }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider />
      <v-layout>
        <v-spacer />
        <v-flex xs5 sm3 class="pr-2 headline" style="text-align: right;">
          <small>Total:</small> ${{ total.toFixed(2) }}
        </v-flex>
      </v-layout>
    <v-divider />
    <v-form :ref="$options.name" v-model="valid" >
      <v-layout wrap>
        <v-flex xs8 sm6 md4>
          <v-text-field
            label="Credit Card Number"
            v-model="creditCardNumber"
            mask="credit-card"
            placeholder="0000-0000-0000-0000"
            :rules="creditCardNumberRules"
          />
        </v-flex>
        <v-spacer />
        <v-flex xs12>
            <v-layout wrap align-center>
              <v-flex xs12>
                <h6>{{ $t('registration.paymentForm.creditCardExpiry') }}</h6>
              </v-flex>
              <v-flex xs4 sm3 md2>
                <v-select
                  :label="$t('registration.paymentForm.expiryMonth')"
                  v-model="creditCardExpiryMonth"
                  :items="months"
                  :rules="creditCardExpiryMonthRules"
                />
              </v-flex>
              <div style="padding:0 5px;">/</div>
              <v-flex xs4 sm3 md2>
                <v-select
                  :label="$t('registration.paymentForm.expiryYear')"
                  v-model="creditCardExpiryYear"
                  :items="years"
                  :rules="creditCardExpiryYearRules"
                />
              </v-flex>
              <v-spacer />
            </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex xs12>
          <v-layout align-end>
            <v-flex xs6 sm4 md3>
              <v-text-field
                :label="$t('registration.paymentForm.creditCardCVV')"
                v-model="creditCardCVV2"
                :rules="creditCardCVV2Rules"
                mask="###"
              />
            </v-flex>
            <v-flex xs6 sm4 md3>
              <v-btn 
                flat
                color="primary"
                @click="cvvDialog = true"
              >
                {{$t('registration.paymentForm.whatIsCVV')}}
              </v-btn>
              <v-dialog 
                v-model="cvvDialog"
                max-width="300"
              >
                <v-img 
                  max-width="300"
                  src="./img/cc-ccv-en.png"
                />
              </v-dialog>
            </v-flex>
            <v-spacer />
          </v-layout>
        </v-flex>
      </v-layout>
      <h5>Billing Address</h5>
      <v-layout wrap>
        <v-flex xs12 v-show="!addBillingAddress">
          <address>
            {{ parentName.fname }} {{ parentName.lname }}<br>
            {{ defaultAddress.address }} <wbr>{{ defaultAddress.address2 }}<br>
            {{ defaultAddress.city }} {{ defaultAddress.state }}, {{ defaultAddress.zip }}<br>
            {{ defaultAddress.country }}
          </address>
        </v-flex>
        <v-checkbox
          :label="$t('registration.paymentForm.useBillingAddress')"
          v-model="addBillingAddress"
        ></v-checkbox>
      </v-layout>
      <v-layout v-show="addBillingAddress" wrap>
        <v-flex xs12 sm5 class="pr-2">
          <v-text-field
            :label="$t('registration.paymentForm.fname')"
            v-model="billingFName"
            :rules="billingFNameRules"
            required
          />
        </v-flex>
        <v-flex xs12 sm5>
          <v-text-field
            :label="$t('registration.paymentForm.lname')"
            v-model="billingLName"
            :rules="billingLNameRules"
            required
          />
        </v-flex>
        <v-flex xs12 sm8>
          <v-text-field
            :label="$t('registration.paymentForm.address')"
            v-model="billingAddress"
            :rules="billingAddressRules"
          />
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            :label="$t('registration.paymentForm.address2')"
            v-model="billingAddress2"
          />
        </v-flex>
        <v-flex xs12 sm7 class="px-1">
          <v-text-field
            :label="$t('registration.paymentForm.city')"
            v-model="billingCity"
            :rules="billingCityRules"
          />
        </v-flex>
        <v-flex xs6 sm2 class="px-1">
          <v-autocomplete
            :items="states"
            item-text="name"
            item-value="abbreviation"
            :label="stateLabel"
            v-model="billingState"
            :rules="billingStateRules"
          />
        </v-flex>
        <v-flex xs6 sm3 class="px-1">
          <v-text-field
            :label="zipLabel"
            v-model="billingZip"
            required
            :mask="zipMask"
            :rules="billingZipRules"
          />
        </v-flex>
        <v-flex>
          <v-radio-group
          :label="$t('registration.paymentForm.country')+':'"
          v-model="billingCountry"
          :rules="billingCountryRules"
          row
          mandatory
        >
          <v-radio
            :label="$t('registration.playerForm.citizen_us')"
            value="USA"
          />
          <v-radio
            :label="$t('registration.playerForm.citizen_can')"
            value="CAN"
          />
          <v-radio
            :label="$t('registration.playerForm.citizen_other')"
            value="Other"
          />
        </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-btn color="primary" @click="validate">Submit</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-sheet>
</template>

<script>
  import statesUSJson from '@/assets/states_us.json'
  import statesCANJson from '@/assets/states_can.json'

  export default {
    name: 'PaymentForm',
    data () {
      return {
        creditCardNumberRules: [(v) => !!v || this.$t('validation.creditCardNumberRequired')],
        creditCardExpiryMonthRules: [(v) => !!v || this.$t('validation.creditCardExpirationRequired')],
        creditCardExpiryYearRules: [(v) => !!v || this.$t('validation.creditCardExpirationRequired')],
        creditCardCVV2Rules: [(v) => !!v || this.$t('validation.creditCardCVVRequired')],
        billingLNameRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingNameRequired')],
        billingFNameRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingNameRequired')],
        billingAddressRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingAddressRequired')],
        billingCityRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingAddressRequired')],
        billingStateRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingAddressRequired')],
        billingZipRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingAddressRequired')],
        billingCountryRules: [(v) => v || !this.addBillingAddress || this.$t('validation.billingAddressRequired')],
        creditCardNumber: '',
        creditCardExpiryMonth: '',
        creditCardExpiryYear: '',
        creditCardCVV2: '',
        billingLName: '',
        billingFName: '',
        billingAddress: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        billingCountry: '',
        addBillingAddress: false,
        cvvDialog: false,
        valid: false
      }
    },
    props: {
      registration: Object,
      event: Object
    },
    computed: {
      months() {
        return [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
      },
      years() {
        let startYear = new Date().getFullYear()
        let years = []
        for (let i = 0; i < 10; i++) {
          years.push((startYear + i).toString())
        }
        return years
      },
      states () {
        switch (this.billingCountry || this.teamCountry) {
          case 'USA':
            return statesUSJson
          case 'US':
            return statesUSJson
          case 'CAN':
            return statesCANJson
          case 'CA':
            return statesCANJson
          default:
            return statesUSJson
        }
      },
      teamCountry () {
        return this.$store.state.team ? this.$store.state.team.country : 'CAN'
      },
      stateLabel () {
        switch (this.billingCountry || this.teamCountry) {
          case 'USA':
            return this.$t('registration.playerForm.state_us')
          case 'US':
            return this.$t('registration.playerForm.state_us')
          case 'CAN':
            return this.$t('registration.playerForm.state_can')
          case 'CA':
            return this.$t('registration.playerForm.state_can')
          default:
            return this.$t('registration.playerForm.state_us')
        }
      },
      zipLabel () {
        switch (this.billingCountry || this.teamCountry) {
          case 'USA':
            return this.$t('registration.playerForm.zip_us')
          case 'US':
            return this.$t('registration.playerForm.zip_us')
          case 'CAN':
            return this.$t('registration.playerForm.zip_can')
          case 'CA':
            return this.$t('registration.playerForm.zip_can')
          default:
            return this.$t('registration.playerForm.zip_us')
        }
      },
      zipMask () {
        switch (this.billingCountry || this.teamCountry) {
          case 'USA':
            return this.$t('inputMasks.usZip')
          case 'US':
            return this.$t('inputMasks.usZip')
          case 'CAN':
            return this.$t('inputMasks.canZip')
          case 'CA':
            return this.$t('inputMasks.canZip')
          default:
            return this.$t('inputMasks.usZip')
        }
      },
      creditCardExpiration () {
        return this.creditCardExpiryMonth + '/' + this.creditCardExpiryYear
      },
      parentName () {
        if(!Array.isArray(this.registration.guardians) || this.registration.guardians.length < 1) {
          return {
            fname: '',
            lname: ''
          }
        }
        return {
          fname: this.registration.guardians[0].fname,
          lname: this.registration.guardians[0].lname,
        }
      },
      defaultAddress () {
        return {
          address: this.registration.address,
          address2: this.registration.address2,
          city: this.registration.city,
          state: this.registration.state,
          zip: this.registration.zip,
          country: this.registration.country
        }
      },
      total () {
        let total = 0
        if(this.registration.status == 'pending' && this.event.id) {
          total += parseFloat(this.event.total)
        }
        return total
      }
    },
    methods: {
      getEventName () {
        return this.event ? this.event.name : ''
      },
      getEventCost() {
        return this.event ?  parseFloat(this.event.total).toFixed(2) : '--'
      },
      validate() {
        let charge = {}
        if(this.$refs[this.$options.name].validate()) {
          charge = {
            'creditcard': this.creditCardNumber,
            'creditcard-expiration': this.creditCardExpiration,
            'creditcard-cvv2': this.creditCardCVV2,
            'billing-fname': this.addBillingAddress ? this.billingFName : this.parentName.fname,
            'billing-lname': this.addBillingAddress ? this.billingLName : this.parentName.lname,
            'billing-address': this.addBillingAddress ? this.billingAddress + ' ' + this.billingAddress2 : this.defaultAddress.address + ' ' + this.defaultAddress.address2,
            'billing-city': this.addBillingAddress ? this.billingCity : this.defaultAddress.city,
            'billing-state': this.addBillingAddress ? this.billingState : this.defaultAddress.state,
            'billing-zip': this.addBillingAddress ? this.billingZip: this.defaultAddress.zip,
            'billing-country': this.addBillingAddress ? this.billingCountry : this.defaultAddress.country
          }
          this.$emit('submit', charge)
        } else {
          return false
        }
      }
    }
  }
</script>

<style scoped>

</style>